"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _PlatformPeg = require("../PlatformPeg");

var _PlatformPeg2 = _interopRequireDefault(_PlatformPeg);

var _MatrixClientPeg = require("../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Event indexing class that wraps the platform specific event indexing.
 */
/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var EventIndex = function () {
    function EventIndex() {
        var _this = this;

        (0, _classCallCheck3.default)(this, EventIndex);

        this.onSync = async function (state, prevState, data) {
            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();

            if (prevState === "PREPARED" && state === "SYNCING") {
                var addInitialCheckpoints = async function addInitialCheckpoints() {
                    var client = _MatrixClientPeg2.default.get();
                    var rooms = client.getRooms();

                    var isRoomEncrypted = function isRoomEncrypted(room) {
                        return client.isRoomEncrypted(room.roomId);
                    };

                    // We only care to crawl the encrypted rooms, non-encrypted.
                    // rooms can use the search provided by the homeserver.
                    var encryptedRooms = rooms.filter(isRoomEncrypted);

                    console.log("EventIndex: Adding initial crawler checkpoints");

                    // Gather the prev_batch tokens and create checkpoints for
                    // our message crawler.
                    await _promise2.default.all(encryptedRooms.map(async function (room) {
                        var timeline = room.getLiveTimeline();
                        var token = timeline.getPaginationToken("b");

                        console.log("EventIndex: Got token for indexer", room.roomId, token);

                        var backCheckpoint = {
                            roomId: room.roomId,
                            token: token,
                            direction: "b"
                        };

                        var forwardCheckpoint = {
                            roomId: room.roomId,
                            token: token,
                            direction: "f"
                        };

                        await indexManager.addCrawlerCheckpoint(backCheckpoint);
                        await indexManager.addCrawlerCheckpoint(forwardCheckpoint);
                        _this.crawlerCheckpoints.push(backCheckpoint);
                        _this.crawlerCheckpoints.push(forwardCheckpoint);
                    }));
                };

                // If our indexer is empty we're most likely running Riot the
                // first time with indexing support or running it with an
                // initial sync. Add checkpoints to crawl our encrypted rooms.
                var eventIndexWasEmpty = await indexManager.isEventIndexEmpty();
                if (eventIndexWasEmpty) await addInitialCheckpoints();

                // Start our crawler.
                _this.startCrawler();
                return;
            }

            if (prevState === "SYNCING" && state === "SYNCING") {
                // A sync was done, presumably we queued up some live events,
                // commit them now.
                console.log("EventIndex: Committing events");
                await indexManager.commitLiveEvents();
                return;
            }
        };

        this.onRoomTimeline = async function (ev, room, toStartOfTimeline, removed, data) {
            // We only index encrypted rooms locally.
            if (!_MatrixClientPeg2.default.get().isRoomEncrypted(room.roomId)) return;

            // If it isn't a live event or if it's redacted there's nothing to
            // do.
            if (toStartOfTimeline || !data || !data.liveEvent || ev.isRedacted()) {
                return;
            }

            // If the event is not yet decrypted mark it for the
            // Event.decrypted callback.
            if (ev.isBeingDecrypted()) {
                var eventId = ev.getId();
                _this.liveEventsForIndex.add(eventId);
            } else {
                // If the event is decrypted or is unencrypted add it to the
                // index now.
                await _this.addLiveEventToIndex(ev);
            }
        };

        this.onEventDecrypted = async function (ev, err) {
            var eventId = ev.getId();

            // If the event isn't in our live event set, ignore it.
            if (!_this.liveEventsForIndex.delete(eventId)) return;
            if (err) return;
            await _this.addLiveEventToIndex(ev);
        };

        this.onTimelineReset = async function (room, timelineSet, resetAllTimelines) {
            if (room === null) return;

            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();
            if (!_MatrixClientPeg2.default.get().isRoomEncrypted(room.roomId)) return;

            var timeline = room.getLiveTimeline();
            var token = timeline.getPaginationToken("b");

            var backwardsCheckpoint = {
                roomId: room.roomId,
                token: token,
                fullCrawl: false,
                direction: "b"
            };

            console.log("EventIndex: Added checkpoint because of a limited timeline", backwardsCheckpoint);

            await indexManager.addCrawlerCheckpoint(backwardsCheckpoint);

            _this.crawlerCheckpoints.push(backwardsCheckpoint);
        };

        this.crawlerCheckpoints = [];
        // The time that the crawler will wait between /rooms/{room_id}/messages
        // requests
        this._crawlerTimeout = 3000;
        // The maximum number of events our crawler should fetch in a single
        // crawl.
        this._eventsPerCrawl = 100;
        this._crawler = null;
        this.liveEventsForIndex = new _set2.default();
    }

    (0, _createClass3.default)(EventIndex, [{
        key: "init",
        value: async function init() {
            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();

            await indexManager.initEventIndex();
            console.log("EventIndex: Successfully initialized the event index");

            this.crawlerCheckpoints = await indexManager.loadCheckpoints();
            console.log("EventIndex: Loaded checkpoints", this.crawlerCheckpoints);

            this.registerListeners();
        }
    }, {
        key: "registerListeners",
        value: function registerListeners() {
            var client = _MatrixClientPeg2.default.get();

            client.on('sync', this.onSync);
            client.on('Room.timeline', this.onRoomTimeline);
            client.on('Event.decrypted', this.onEventDecrypted);
            client.on('Room.timelineReset', this.onTimelineReset);
        }
    }, {
        key: "removeListeners",
        value: function removeListeners() {
            var client = _MatrixClientPeg2.default.get();
            if (client === null) return;

            client.removeListener('sync', this.onSync);
            client.removeListener('Room.timeline', this.onRoomTimeline);
            client.removeListener('Event.decrypted', this.onEventDecrypted);
            client.removeListener('Room.timelineReset', this.onTimelineReset);
        }
    }, {
        key: "addLiveEventToIndex",
        value: async function addLiveEventToIndex(ev) {
            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();

            if (["m.room.message", "m.room.name", "m.room.topic"].indexOf(ev.getType()) == -1) {
                return;
            }

            var e = ev.toJSON().decrypted;
            var profile = {
                displayname: ev.sender.rawDisplayName,
                avatar_url: ev.sender.getMxcAvatarUrl()
            };

            indexManager.addEventToIndex(e, profile);
        }
    }, {
        key: "crawlerFunc",
        value: async function crawlerFunc() {
            var _this2 = this;

            // TODO either put this in a better place or find a library provided
            // method that does this.
            var sleep = async function sleep(ms) {
                return new _promise2.default(function (resolve) {
                    return setTimeout(resolve, ms);
                });
            };

            var cancelled = false;

            console.log("EventIndex: Started crawler function");

            var client = _MatrixClientPeg2.default.get();
            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();

            this._crawler = {};

            this._crawler.cancel = function () {
                cancelled = true;
            };

            var _loop = async function _loop() {
                // This is a low priority task and we don't want to spam our
                // homeserver with /messages requests so we set a hefty timeout
                // here.
                await sleep(_this2._crawlerTimeout);

                console.log("EventIndex: Running the crawler loop.");

                if (cancelled) {
                    return "break";
                }

                var checkpoint = _this2.crawlerCheckpoints.shift();

                /// There is no checkpoint available currently, one may appear if
                // a sync with limited room timelines happens, so go back to sleep.
                if (checkpoint === undefined) {
                    return "continue";
                }

                console.log("EventIndex: crawling using checkpoint", checkpoint);

                // We have a checkpoint, let us fetch some messages, again, very
                // conservatively to not bother our homeserver too much.
                var eventMapper = client.getEventMapper();
                // TODO we need to ensure to use member lazy loading with this
                // request so we get the correct profiles.
                var res = void 0;

                try {
                    res = await client._createMessagesRequest(checkpoint.roomId, checkpoint.token, _this2._eventsPerCrawl, checkpoint.direction);
                } catch (e) {
                    console.log("EventIndex: Error crawling events:", e);
                    _this2.crawlerCheckpoints.push(checkpoint);
                    return "continue";
                }

                if (res.chunk.length === 0) {
                    console.log("EventIndex: Done with the checkpoint", checkpoint);
                    // We got to the start/end of our timeline, lets just
                    // delete our checkpoint and go back to sleep.
                    await indexManager.removeCrawlerCheckpoint(checkpoint);
                    return "continue";
                }

                // Convert the plain JSON events into Matrix events so they get
                // decrypted if necessary.
                var matrixEvents = res.chunk.map(eventMapper);
                var stateEvents = [];
                if (res.state !== undefined) {
                    stateEvents = res.state.map(eventMapper);
                }

                var profiles = {};

                stateEvents.forEach(function (ev) {
                    if (ev.event.content && ev.event.content.membership === "join") {
                        profiles[ev.event.sender] = {
                            displayname: ev.event.content.displayname,
                            avatar_url: ev.event.content.avatar_url
                        };
                    }
                });

                var decryptionPromises = [];

                matrixEvents.forEach(function (ev) {
                    if (ev.isBeingDecrypted() || ev.isDecryptionFailure()) {
                        // TODO the decryption promise is a private property, this
                        // should either be made public or we should convert the
                        // event that gets fired when decryption is done into a
                        // promise using the once event emitter method:
                        // https://nodejs.org/api/events.html#events_events_once_emitter_name
                        decryptionPromises.push(ev._decryptionPromise);
                    }
                });

                // Let us wait for all the events to get decrypted.
                await _promise2.default.all(decryptionPromises);

                // We filter out events for which decryption failed, are redacted
                // or aren't of a type that we know how to index.
                var isValidEvent = function isValidEvent(value) {
                    return ["m.room.message", "m.room.name", "m.room.topic"].indexOf(value.getType()) >= 0 && !value.isRedacted() && !value.isDecryptionFailure();
                    // TODO do we need to check if the event has all the valid
                    // attributes?
                };

                // TODO if there are no events at this point we're missing a lot
                // decryption keys, do we want to retry this checkpoint at a later
                // stage?
                var filteredEvents = matrixEvents.filter(isValidEvent);

                // Let us convert the events back into a format that EventIndex can
                // consume.
                var events = filteredEvents.map(function (ev) {
                    var jsonEvent = ev.toJSON();

                    var e = void 0;
                    if (ev.isEncrypted()) e = jsonEvent.decrypted;else e = jsonEvent;

                    var profile = {};
                    if (e.sender in profiles) profile = profiles[e.sender];
                    var object = {
                        event: e,
                        profile: profile
                    };
                    return object;
                });

                // Create a new checkpoint so we can continue crawling the room for
                // messages.
                var newCheckpoint = {
                    roomId: checkpoint.roomId,
                    token: res.end,
                    fullCrawl: checkpoint.fullCrawl,
                    direction: checkpoint.direction
                };

                console.log("EventIndex: Crawled room", client.getRoom(checkpoint.roomId).name, "and fetched", events.length, "events.");

                try {
                    var eventsAlreadyAdded = await indexManager.addHistoricEvents(events, newCheckpoint, checkpoint);
                    // If all events were already indexed we assume that we catched
                    // up with our index and don't need to crawl the room further.
                    // Let us delete the checkpoint in that case, otherwise push
                    // the new checkpoint to be used by the crawler.
                    if (eventsAlreadyAdded === true && newCheckpoint.fullCrawl !== true) {
                        console.log("EventIndex: Checkpoint had already all events", "added, stopping the crawl", checkpoint);
                        await indexManager.removeCrawlerCheckpoint(newCheckpoint);
                    } else {
                        _this2.crawlerCheckpoints.push(newCheckpoint);
                    }
                } catch (e) {
                    console.log("EventIndex: Error durring a crawl", e);
                    // An error occurred, put the checkpoint back so we
                    // can retry.
                    _this2.crawlerCheckpoints.push(checkpoint);
                }
            };

            _loop2: while (!cancelled) {
                var _ret = await _loop();

                switch (_ret) {
                    case "break":
                        break _loop2;

                    case "continue":
                        continue;}
            }

            this._crawler = null;

            console.log("EventIndex: Stopping crawler function");
        }
    }, {
        key: "startCrawler",
        value: function startCrawler() {
            if (this._crawler !== null) return;
            this.crawlerFunc();
        }
    }, {
        key: "stopCrawler",
        value: function stopCrawler() {
            if (this._crawler === null) return;
            this._crawler.cancel();
        }
    }, {
        key: "close",
        value: async function close() {
            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();
            this.removeListeners();
            this.stopCrawler();
            return indexManager.closeEventIndex();
        }
    }, {
        key: "search",
        value: async function search(searchArgs) {
            var indexManager = _PlatformPeg2.default.get().getEventIndexingManager();
            return indexManager.searchEventIndex(searchArgs);
        }
    }]);
    return EventIndex;
}();

exports.default = EventIndex;
module.exports = exports["default"];
//# sourceMappingURL=EventIndex.js.map